import { useEffect } from 'react';

const useScript = (url, id, condition) => {
  useEffect(() => {
    if (!condition) {
      return;
    }

    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.id = id;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, id, condition]);
};

export default useScript;
